/* eslint-disable react-hooks/exhaustive-deps */
import { IMeetingInfo } from "@/common/entity/Entity";
import { ETheme, EThemeBackground } from "@/common/entity/Enum";
import { BuildRCAttribute } from "@/common/function/RCAttribute";
import ErrorPage from "@/components/ui/ErrorPage";
import { RenderIconHome, RenderIconResource, RenderIconSetting } from "@/components/ui/Icons/IconsCustom";
import LoadingCustom from "@/components/ui/Loading";
import { MenuBar } from "@/components/ui/Tablist";
import { IItemBarProps } from "@/components/ui/Tablist/Models";
import { baContainer } from "@/ioc";
import {
  DateTimePeriodDto,
  IAppointmentManager,
  IOutlookSettingsRepository,
  OutlookAppointmentRecurrenceDto,
  OutlookRecipientDto,
  TokenIAppointmentManager,
  TokenIOutlookSettingsRepository,
} from "@/out-look/interfaces";
import { IOutlookAppointmentService, OutlookAppointmentService } from "@/out-look/services";
import { RootState } from "@/redux";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { IResourceStore } from "@/redux/slices/resources/ResourceReducerModel";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { IFetchResourceRequest, IFilterResource, IOrganizationService, OrganizationInfo, Organizer, ResourceInfo, TokenIOrganizationService, TransitiveMemberOfGroup } from "@/services";
import { AttendeeInfo } from "@/services/attendee-service/entity/AttendeeEntity";
import { DateTimePeriod, OutLookInfo } from "@/services/organization-service/entity/OutLookEntity";
import Home from "@/view/addin/home";
import ResourceList from "@/view/addin/resource-list/ResourceListContainer";
import Setting from "@/view/addin/settings/SettingContainer";
import { FluentProvider, Theme, webDarkTheme, webLightTheme } from "@fluentui/react-components";
import { MutableRefObject, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import NotificationContainer from "../notification/NotificationContainer";
import { IResourceFinderProps, TAB_LIST } from "./Models";
import { BaseParentWrapper, BaseWrapper, TabListWrapper } from "./Styles";
import { config } from "@/config";
import { DateTimeFormatHelper } from "@/utilities";
import { cloneDeep } from "lodash";
import { DateTimeConverter } from "@/shared";
import { IAuthenticationService, TokenIAuthenticationService } from "@/authentication";
import { INotificationStore } from "@/redux/slices/notification/NotificationModel";

const ResourceFinder = (props: IResourceFinderProps) => {
  const { t } = useTranslation();
  const [currentTabActive, setCurrentTabActive] = useState(TAB_LIST.RESOURCE);
  const isMounted1: MutableRefObject<boolean> = useRef(false);
  const isMounted2: MutableRefObject<boolean> = useRef(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const orgStore: IOrganizationStore = useSelector((state: RootState) => state.orgInfo) as IOrganizationStore;
  const notificationStore: INotificationStore = useSelector((state: RootState) => state.notificationInfo) as INotificationStore;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const settingStore: ISettingStore = useSelector((state: RootState) => state.settingInfo) as ISettingStore;

  const resourceStore: IResourceStore = useSelector((state: RootState) => state.resources) as IResourceStore;

  useEffect(() => {
    subscribeOutlook();
  }, []);

  useEffect(() => {
    if (orgStore.outlookInfo?.uid && !orgStore.orgInfo) {
      getOrgInfo(orgStore.outlookInfo.uid, orgStore.outlookInfo.isReOpen, orgStore.outlookInfo.isRecurringMaster);
    }
  }, [orgStore.outlookInfo?.uid ]);

  useEffect(() => {
    if (orgStore.orgInfo) {
      getCategorization(orgStore.orgInfo.tenantId, orgStore.orgInfo.guid);
      props.getSettingOrgInfo &&
        props.getSettingOrgInfo({
          orgId: orgStore.orgInfo.guid,
          tenantId: orgStore.orgInfo.tenantId,
        });
      const outlookSettingsRepository: IOutlookSettingsRepository = baContainer.resolve(TokenIOutlookSettingsRepository);
      outlookSettingsRepository.SetAppSetting("isExternal", orgStore.orgInfo.isExternal);
    }
  }, [orgStore.orgInfo]);

  useEffect(() => {
    if (settingStore) {
      const filterClone: IFilterResource = cloneDeep(
        resourceStore.filterResource || {
          name: null,
          categoryIds: null,
          locationIds: null,
          categoryCondition: null,
        }
      );
      filterClone.locationIds = settingStore.defaultLocation?.length ? settingStore.defaultLocation.split(",") : null;
      filterClone.categoryIds = settingStore.defaultCategories?.length ? settingStore.defaultCategories.split(",") : null;
      if (props.updateFilterResource) {
        props.updateFilterResource(filterClone);
      }
    }
  }, [settingStore.defaultLocation, settingStore.defaultCategories]);

  const getOrgInfo = (outlookUid: string, isReOpen?: boolean, isRecurringMaster?: boolean): void => {
    if (props.getOrgInfo) {
      props.getOrgInfo(outlookUid, isReOpen, isRecurringMaster);
    }
  };

  const getCategorization = (tenantId: string, orgId: string): void => {
    if (props.getCategorization) {
      props.getCategorization(tenantId, orgId);
    }
  };

  const subscribeOutlook = (): void => {
    const appointmentManager: IAppointmentManager = baContainer.resolve(TokenIAppointmentManager);
    appointmentManager.OnStarted.Subscribe(async function () {
      // const timeZoneHelperService: ITimeZoneHelperService = baContainer.resolve(TokenITimeZoneHelperService);
      await onStartSubscribeOutlook();
      appointmentManager.OnDateTimeChanged.Subscribe(async function (arg: DateTimePeriodDto) {
        const argClone = cloneDeep(arg);
        if (argClone?.Start && argClone?.End && argClone.Start.getUTCHours() === 0 && argClone.Start.getMinutes() === 0 && DateTimeFormatHelper.isAllDay(argClone?.Start, argClone?.End)) {
          const dateTimeConvertString = DateTimeFormatHelper.convertStartAndEndTimeAllDayEvent(argClone?.Start, argClone?.End);
          const meetingInfosReq: IMeetingInfo[] = [
            {
              StartTime: dateTimeConvertString.startTime,
              EndTime: dateTimeConvertString.endTime,
            },
          ];
          if (props.onConvertDateTimeToUTC) {
            const olOrganizerService: IOrganizationService = baContainer.resolve(TokenIOrganizationService);
            const organizer = await olOrganizerService.GetCurrentOrganizer();
            const resp = await props.onConvertDateTimeToUTC({
              MeetingInfos: meetingInfosReq,
              TimeZone: organizer?.TimeZoneStandardName || "",
            });
            if (!resp.error) {
              argClone.Start = new Date(resp.data.meetingInfos[0].startTime);
              argClone.End = new Date(resp.data.meetingInfos[0].endTime);
            }
          }
        }
        if (argClone) {
          const appointmentManager: IAppointmentManager = baContainer.resolve(TokenIAppointmentManager);
          argClone.StartTimeNotConvert = new Date(arg?.Start || "");
          argClone.EndTimeNotConvert = new Date(arg?.End || "");
          argClone.DisplayStartTime = appointmentManager.ConvertTimeDisplayLocalUTC(new Date(argClone.Start || ""));
          argClone.DisplayEndTime = appointmentManager.ConvertTimeDisplayLocalUTC(new Date(argClone.End || ""));
        }
        if (props.updateTimeOfOutlook) {
          props.updateTimeOfOutlook(argClone);
        }
      });

      appointmentManager.OnRecipientsChanged.Subscribe((resources: Array<OutlookRecipientDto>) => {
        //Call API\
        if (props.updateResourceSelectedFromOutlook) {
          props.updateResourceSelectedFromOutlook(resources);
        }
        //Thêm/xoá resource từ outlook
        //Duajw treen resources

        // Load resource khi re open metting
        //Check xem có sl
      });

      appointmentManager.OnRecurrenceChanged.Subscribe(async (args: OutlookAppointmentRecurrenceDto) => {
        const argsClone = cloneDeep(args);
        if (argsClone?.Occurrences) {
          argsClone.Occurrences = argsClone.Occurrences.filter((item) => !item.IsDeleted);
        }
        const isRecurringAllDay =
          argsClone.IsRecurringMaster &&
          argsClone.Series?.Start &&
          argsClone.Series?.End &&
          argsClone.Series.Start.getUTCHours() === 0 &&
          argsClone.Series.Start.getMinutes() === 0 &&
          argsClone.Series.End.getUTCHours() === 0 &&
          argsClone.Series.End.getMinutes() === 0 &&
          DateTimeFormatHelper.isAllDay(argsClone.Series?.Start, argsClone.Series?.End);
        if (isRecurringAllDay) {
          const occurrencesFormatString = argsClone.Occurrences.map((item) => {
            const dateTimeConvertStringRcc = DateTimeFormatHelper.convertStartAndEndTimeAllDayEvent(item?.Start || new Date(), item?.End || new Date(), true);
            return {
              StartTime: dateTimeConvertStringRcc.startTime,
              EndTime: dateTimeConvertStringRcc.endTime,
            };
          });
          if (props.onConvertDateTimeToUTC) {
            const olOrganizerService: IOrganizationService = baContainer.resolve(TokenIOrganizationService);
            const organizer = await olOrganizerService.GetCurrentOrganizer();
            const resp = await props.onConvertDateTimeToUTC({
              MeetingInfos: occurrencesFormatString,
              TimeZone: organizer?.TimeZoneStandardName || "",
            });
            if (!resp.error) {
              argsClone.Occurrences = resp.data.meetingInfos.map((item) => {
                return {
                  Start: new Date(item.startTime),
                  End: new Date(item.endTime),
                  StartTicks: DateTimeConverter.convertToNetTicks(new Date(item.startTime)),
                  EndTicks: DateTimeConverter.convertToNetTicks(new Date(item.endTime)),
                };
              });
            }
          }
        }
        if (props.updateRecurringOfOutlook) {
          const appointmentManager: IAppointmentManager = baContainer.resolve(TokenIAppointmentManager);
          argsClone.Series.StartTimeNotConvert = args.Series.Start;
          argsClone.Series.EndTimeNotConvert = args.Series.End;
          if (argsClone.Occurrences.length && isRecurringAllDay) {
            argsClone.Series.Start = new Date(argsClone.Occurrences[0]?.Start || "");
            argsClone.Series.End = new Date(argsClone.Occurrences[0]?.End || "");
            argsClone.Series.DisplayStartTime = appointmentManager.ConvertTimeDisplayLocalUTC(new Date(argsClone.Occurrences[0]?.Start || ""));
            argsClone.Series.DisplayEndTime = appointmentManager.ConvertTimeDisplayLocalUTC(new Date(argsClone.Occurrences[0]?.End || ""));
          } else {
            argsClone.Series.DisplayStartTime = appointmentManager.ConvertTimeDisplayLocalUTC(new Date(args.Series.Start || ""));
            argsClone.Series.DisplayEndTime = appointmentManager.ConvertTimeDisplayLocalUTC(new Date(args.Series.End || ""));
          }
          props.updateRecurringOfOutlook(argsClone);
        }
      });
    });
    appointmentManager.Start();
  };

  const onStartSubscribeOutlook = async (): Promise<void> => {
    const olAppointmentService: IOutlookAppointmentService = new OutlookAppointmentService();
    const olOrganizerService: IOrganizationService = baContainer.resolve(TokenIOrganizationService);

    const outlookSettingsRepository: IOutlookSettingsRepository = baContainer.resolve(TokenIOutlookSettingsRepository);

    const currentAppointment = olAppointmentService.GetCurrentAppointment();
    const organizer = await olOrganizerService.GetCurrentOrganizer();
    const currentAppointmentClone = cloneDeep(currentAppointment);
    if (currentAppointmentClone?.Occurrences) {
      currentAppointmentClone.Occurrences = currentAppointmentClone.Occurrences.filter((item) => !item.IsDeleted);
    }
    if (
      currentAppointmentClone?.Start &&
      currentAppointmentClone?.End &&
      currentAppointmentClone.Start.getUTCHours() === 0 &&
      currentAppointmentClone.Start.getMinutes() === 0 &&
      DateTimeFormatHelper.isAllDay(currentAppointmentClone?.Start, currentAppointmentClone?.End)
    ) {
      const dateTimeConvertString = DateTimeFormatHelper.convertStartAndEndTimeAllDayEvent(currentAppointmentClone?.Start, currentAppointmentClone?.End);
      let meetingInfosReq: IMeetingInfo[] = [
        {
          StartTime: dateTimeConvertString.startTime,
          EndTime: dateTimeConvertString.endTime,
        },
      ];
      if (currentAppointmentClone.IsRecurringMaster && currentAppointmentClone.Occurrences.length) {
        const occurrencesFormatString = currentAppointmentClone.Occurrences.map((item) => {
          const dateTimeConvertStringRcc = DateTimeFormatHelper.convertStartAndEndTimeAllDayEvent(item?.Start || new Date(), item?.End || new Date(), true);
          return {
            StartTime: dateTimeConvertStringRcc.startTime,
            EndTime: dateTimeConvertStringRcc.endTime,
          };
        });
        meetingInfosReq = occurrencesFormatString;
      }
      if (props.onConvertDateTimeToUTC) {
        const resp = await props.onConvertDateTimeToUTC({
          MeetingInfos: meetingInfosReq,
          TimeZone: organizer?.TimeZoneStandardName || "",
        });
        if (!resp.error) {
          currentAppointmentClone.Start = new Date(resp.data.meetingInfos[0].startTime);
          currentAppointmentClone.End = new Date(resp.data.meetingInfos[0].endTime);
          if (currentAppointmentClone.IsRecurringMaster) {
            currentAppointmentClone.Occurrences = resp.data.meetingInfos.map((item) => {
              return {
                Start: new Date(item.startTime),
                End: new Date(item.endTime),
                StartTicks: DateTimeConverter.convertToNetTicks(new Date(item.startTime)),
                EndTicks: DateTimeConverter.convertToNetTicks(new Date(item.endTime)),
              };
            });
          }
        }
      }
    }
    if (currentAppointmentClone) {
      const isRccAllDay =
        currentAppointment?.IsRecurringMaster &&
        currentAppointment?.Occurrences.length &&
        currentAppointment.Start.getUTCHours() === 0 &&
        currentAppointment.Start.getMinutes() === 0 &&
        DateTimeFormatHelper.isAllDay(currentAppointment?.Start, currentAppointment?.End);
      const appointmentManager: IAppointmentManager = baContainer.resolve(TokenIAppointmentManager);
      currentAppointmentClone.StartTimeNotConvert = isRccAllDay ? new Date(currentAppointment?.Occurrences[0].Start || "") : new Date(currentAppointment?.Start || "");
      currentAppointmentClone.EndTimeNotConvert = isRccAllDay ? new Date(currentAppointment?.Occurrences[0].End || "") : new Date(currentAppointment?.End || "");
      //convert
      currentAppointmentClone.DisplayStartTime = new Date(appointmentManager.ConvertTimeDisplayLocalUTC(new Date(currentAppointmentClone.Start)));
      currentAppointmentClone.DisplayEndTime = new Date(appointmentManager.ConvertTimeDisplayLocalUTC(new Date(currentAppointmentClone.End)));
    }
    const recipients: OutlookRecipientDto[] = olAppointmentService.GetCurrentRecipients();

    const themeId = outlookSettingsRepository.GetOutlookTheme();
    console.log("currentAppointmentClone", currentAppointmentClone);
    updateOutlookInfoToRedux(new OutLookInfo(currentAppointmentClone));
    updateOrganizerToRedux(new Organizer(organizer));
    props.addInitAttendee &&
      props.addInitAttendee(
        new AttendeeInfo({
          email: organizer?.Email,
          displayName: organizer?.Name,
          name: organizer?.Name,
          isOrganizer: true,
        })
      );
    updateOutlookThemeToRedux(themeId);
    if (props.updateResourceSelectedFromOutlook) {
      props.updateResourceSelectedFromOutlook(recipients);
    }
  };

  const updateOutlookThemeToRedux = (themeId: string): void => {
    if (props.setTheme) {
      props.setTheme(themeId);
    }
  };

  const updateOutlookInfoToRedux = (outlookInfo: OutLookInfo): void => {
    if (props.updateOutlookInfo) {
      props.updateOutlookInfo(outlookInfo);
    }
  };

  const updateOrganizerToRedux = (organizer: Organizer) => {
    if (props.updateOrganizer) {
      props.updateOrganizer(organizer);
    }
  };

  const nav: IItemBarProps[] = [
    {
      id: TAB_LIST.HOME,
      title: t("Home"),
      icon: <RenderIconHome theme={settingStore.theme} />,
      activeIcon: <RenderIconHome theme={settingStore.theme} isActive={true} />,
      isActive: false,
      path: "/home",
      isTooltip: true,
      disabled: false,
    },
    {
      id: TAB_LIST.RESOURCE,
      title: t("Resources"),
      icon: <RenderIconResource theme={settingStore.theme} />,
      activeIcon: <RenderIconResource theme={settingStore.theme} isActive={true} />,
      isActive: true,
      path: "/resource",
      isTooltip: true,
      disabled: false,
    },
    // {
    //   id: TAB_LIST.COLLEAGUE,
    //   title: t("Find Colleague"),
    //   icon: <RenderIconColleague theme={settingStore.theme} />,
    //   activeIcon: (
    //     <RenderIconColleague theme={settingStore.theme} isActive={true} />
    //   ),
    //   isActive: false,
    //   path: "/colleague",
    //   isTooltip: true,
    //   disabled: false,
    // },
    {
      id: TAB_LIST.SETTING,
      title: t("Settings"),
      icon: <RenderIconSetting theme={settingStore.theme} />,
      activeIcon: <RenderIconSetting theme={settingStore.theme} isActive={true} />,
      isActive: false,
      path: "/settings",
      isTooltip: true,
      disabled: false,
    },
  ];

  const onSwitch = (id: string) => {
    setCurrentTabActive(id as TAB_LIST);
    return id;
  };

  const renderTabContent = () => {
    switch (currentTabActive) {
      case TAB_LIST.HOME:
        return <Home />;
      case TAB_LIST.RESOURCE:
        return <ResourceList />;
      case TAB_LIST.COLLEAGUE:
        return <div>Colleague</div>;
      case TAB_LIST.SETTING:
        return <Setting />;
      default:
        return <div>Home</div>;
    }
  };

  const renderThemFluentUi = (): Theme => {
    if (settingStore.theme === ETheme.Dark) {
      webDarkTheme.colorNeutralBackground1 = EThemeBackground.Dark;
      return webDarkTheme;
    }
    return webLightTheme;
  };

  //save attendee to setting outlook

  useEffect(() => {
    if (resourceStore?.attendees.listAttendee) {
      const attendeeString: string[] = (resourceStore?.attendees.listAttendee || []).map((item) => item.email);
      const outlookSettingsRepository: IOutlookSettingsRepository = baContainer.resolve(TokenIOutlookSettingsRepository);
      outlookSettingsRepository.SetAppSetting("dataAttendee", {
        attendees: attendeeString,
      });
    }
  }, [JSON.stringify(resourceStore?.attendees.listAttendee)]);

  //update selected rs and attendee
  useEffect(() => {
    if (!isMounted1.current) {
      isMounted1.current = true;
    } else {
      if (orgStore.orgInfo && resourceStore?.resourceSelectedInOutlook) {
        updateRsFromChangeOnOutlook();
      }
    }
  }, [resourceStore?.resourceSelectedInOutlook, orgStore.orgInfo]);

  useEffect(() => {
    if (orgStore.outlookInfo && props.onResetNotification && notificationStore.notifications?.length) {
      props.onResetNotification();
    }
    if (orgStore.outlookInfo && orgStore.orgInfo) {
      saveDataOrgInGlobalOutlook(); //save data org to use command.ts
      setIsInitialized(true); // Đánh dấu là đã khởi tạo
      if (!isMounted2.current) {
        isMounted2.current = true;
      } else {
        updateAllRsFromChangeOutlookInfo(orgStore.orgInfo, orgStore.outlookInfo);
      }
    }
  }, [JSON.stringify(orgStore.outlookInfo), orgStore.orgInfo]);

  useEffect(() => {
    if (orgStore.orgInfo) {
      saveTokenOnSessionOfOutlook();
    }
  }, [orgStore.orgInfo]);

  // useEffect(() => {
  //   if (resourceStore.originalSelectedResources?.length) {
  //     const uids = resourceStore.originalSelectedResources.map((item) => item.uuid);
  //     const orgInfo = orgStore.orgInfo;
  //     props.getICalUidExternal && orgInfo && props.getICalUidExternal(uids, orgInfo);
  //   }
  // }, [resourceStore.originalSelectedResources]);

  const saveTokenOnSessionOfOutlook = async () => {
    const authenticationService: IAuthenticationService = baContainer.resolve(TokenIAuthenticationService);
    const appointmentManager: IAppointmentManager = baContainer.resolve(TokenIAppointmentManager);
    const token: string | undefined = await authenticationService.GetUserIdentityToken();
    appointmentManager.SaveDataResourceInfo(
      {
        token,
      },
      "token"
    );
  };

  const saveDataOrgInGlobalOutlook = () => {
    const outlookSettingsRepository: IOutlookSettingsRepository = baContainer.resolve(TokenIOutlookSettingsRepository);
    outlookSettingsRepository.SetAppSetting("dataOrgInfo", {
      orgId: orgStore?.orgInfo?.guid || "",
      tenantId: orgStore?.orgInfo?.tenantId || "root",
      mailOrganizer: orgStore.organizer?.email ? orgStore.organizer?.email?.toLowerCase() : "",
      nameOrganizer: orgStore.organizer?.name ? orgStore.organizer?.name : "",
      emailGroups: (orgStore.orgInfo?.memberOfs || []).map((item) => item.mail),
      urlApi: `${config.API_URL}/${orgStore?.orgInfo?.tenantId}/${orgStore?.orgInfo?.guid}/CreateOrUpdateAppointment`,
      uid: orgStore.orgInfo?.uidOutlook,
    });
  };

  const updateRsFromChangeOnOutlook = () => {
    const concatRsAttendee: ResourceInfo[] | AttendeeInfo[] = [...(resourceStore.selectedResource || []), ...(resourceStore.attendees.listAttendee || [])];
    const lstEmail: string[] = concatRsAttendee?.map((resource: ResourceInfo | AttendeeInfo) => {
      return resource.email;
    });
    const listEmailNotSelected = (resourceStore?.resourceSelectedInOutlook || []).filter((resource: OutlookRecipientDto) => !lstEmail?.includes(resource.Email));

    //if resource is delete from outlook, delete resource on store
    const listEmailFromOutlook: string[] = (resourceStore?.resourceSelectedInOutlook || []).map((item: OutlookRecipientDto) => item.Email);

    const listEmailNotExistInResourceOutlook: string[] = (concatRsAttendee || [])
      .filter((item: ResourceInfo | AttendeeInfo) => !listEmailFromOutlook.includes(item.email))
      .map((resourceInfo: ResourceInfo | AttendeeInfo) => resourceInfo.email);

    if (listEmailNotExistInResourceOutlook.length && props.deleteSelectWhenFromOutlook) {
      props.deleteSelectWhenFromOutlook(listEmailNotExistInResourceOutlook);
    }

    //get resource info from outlook
    if (orgStore.orgInfo && orgStore.outlookInfo && orgStore.organizer && props.getResourcesDataForSelected && listEmailNotSelected.length) {
      const meetingInfos: IMeetingInfo[] = orgStore.outlookInfo.isRecurringMaster
        ? (orgStore.outlookInfo?.occurrences || [])?.map((item: DateTimePeriod) => {
            return {
              StartTime: item.start?.toISOString() || "",
              EndTime: item.end?.toISOString() || "",
              Guid: orgStore.orgInfo?.isExternal ? orgStore.orgInfo?.uidOutlook || undefined : orgStore.orgInfo?.iCalUId,
            };
          })
        : [
            {
              StartTime: orgStore.outlookInfo.start?.toISOString() || "",
              EndTime: orgStore.outlookInfo.end?.toISOString() || "",
              Guid: orgStore.orgInfo?.isExternal ? orgStore.orgInfo?.uidOutlook || undefined : orgStore.orgInfo?.iCalUId,
            },
          ];
      const request: IFetchResourceRequest = {
        orgId: orgStore.orgInfo.guid,
        tenantId: orgStore.orgInfo.tenantId,
        requestBody: {
          Organizer: orgStore.organizer?.email || "",
          IsRecurring: !!orgStore.outlookInfo.isRecurringMaster,
          EmailGroups: orgStore.orgInfo.memberOfs.map((item: TransitiveMemberOfGroup) => item.mail),
          MeetingInfos: meetingInfos,
          IsExternal: orgStore.orgInfo?.isExternal,
          SeriesMasterUId: orgStore.orgInfo?.isExternal ? orgStore.orgInfo?.uidOutlook : undefined,
          Filters: {
            Emails: listEmailNotSelected.map((a) => a.Email).join(" or "),
            NameContains: null,
            CategoryIds: null,
            LocationIds: null,
          },
        },
      };

      props.getResourcesDataForSelected(request, listEmailNotSelected, !!orgStore.outlookInfo?.isRecurringMaster, orgStore.orgInfo);
    }
  };

  const updateAllRsFromChangeOutlookInfo = (orgInfo: OrganizationInfo, outlookInfo: OutLookInfo) => {
    const lstEmail = resourceStore.selectedResource?.map((resource: ResourceInfo) => {
      return resource.email;
    });
    if (lstEmail?.length) {
      const meetingInfos: IMeetingInfo[] = outlookInfo.isRecurringMaster
        ? (outlookInfo?.occurrences || [])?.map((item: DateTimePeriod) => {
            return {
              StartTime: item.start?.toISOString() || "",
              EndTime: item.end?.toISOString() || "",
              Guid: orgInfo?.uidOutlook || undefined,
            };
          })
        : [
            {
              StartTime: outlookInfo.start?.toISOString() || "",
              EndTime: outlookInfo.end?.toISOString() || "",
              Guid: orgInfo?.uidOutlook || undefined,
            },
          ];
      const request: IFetchResourceRequest = {
        orgId: orgInfo.guid || "",
        tenantId: orgInfo?.tenantId || "",
        requestBody: {
          Organizer: orgStore.organizer?.email || "",
          IsRecurring: !!outlookInfo.isRecurringMaster,
          EmailGroups: orgInfo?.memberOfs.map((item: TransitiveMemberOfGroup) => item.mail),
          MeetingInfos: meetingInfos,
          IsExternal: orgStore.orgInfo?.isExternal,
          SeriesMasterUId: orgStore.orgInfo?.isExternal ? orgStore.orgInfo?.uidOutlook : undefined,
          Filters: {
            Emails: lstEmail.map((a) => a).join(" or "),
            NameContains: null,
            CategoryIds: null,
            LocationIds: null,
          },
        },
      };
      if (props.getAllResourcesDataInSelected) {
        props.getAllResourcesDataInSelected(request, !!orgStore.outlookInfo?.isRecurringMaster);
      }
    }
  };

  useEffect(() => {
    if (isInitialized) {
      initBooking(); // Gọi initBooking sau khi đã khởi tạo
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialized]);

  const initBooking = async () => {
    // Added async keyword
    // Logic cho initBooking
    const lstEmail = resourceStore.selectedResource?.map((resource: ResourceInfo) => {
      return resource.email;
    });

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const request = {
      CurrentResourceMails: lstEmail ? lstEmail : [], // Changed 'Email' to 'email'
      OriginalSelectedResource: resourceStore.selectedResource ? resourceStore.selectedResource.map((resource) => resource.email).join(",") : "", // Added null check
      OrganizerEmail: orgStore.organizer?.email, // Changed 'Email' to 'email'
    };
    // const bookingInfo = await resourceService.GetResourcesInCurrentBooking();
  };

  return (
    <FluentProvider theme={renderThemFluentUi()}>
      {orgStore.loading ? (
        <LoadingCustom />
      ) : orgStore.orgInfo ? (
        <BaseParentWrapper className="BaseParentWrapper" $theme={settingStore.theme || undefined} {...BuildRCAttribute("BaseParentWrapper")}>
          {currentTabActive !== TAB_LIST.SETTING ? <NotificationContainer /> : null}
          <BaseWrapper className="BaseWrapper">
            {renderTabContent()}
            <TabListWrapper className="TabListWrapper">
              <MenuBar buttons={nav} onSwitch={onSwitch} currentTabActive={currentTabActive} theme={settingStore.theme || undefined} />
            </TabListWrapper>
          </BaseWrapper>
        </BaseParentWrapper>
      ) : (
        <ErrorPage errorCode={orgStore?.errorCode} />
      )}
    </FluentProvider>
  );
};

export default ResourceFinder;
